import bem from 'utils/bem';

export const block = bem('add-track-modal');
